/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 28th 2022, 4:42:06 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

interface APIStatusNotificationProps {
  open: boolean;
  title: React.ReactNode;
  icon: React.ReactNode;
  message: React.ReactNode;
  actions: React.ReactNode;
  children?: React.ReactNode;
}

export const APIStatusNotification = ({
  open,
  title,
  icon,
  message,
  actions,
  children,
}: APIStatusNotificationProps) => (
  <Dialog open={open} fullWidth maxWidth="xs" className="os-global-centered-alert text-center">
    {title && <DialogTitle>{title}</DialogTitle>}
    <DialogContent className="os-api-status-notification-container">
      <div className="as-global-alert-content">
        <div className="as-global-alert-icon">{icon}</div>
        <div className="as-global-alert-message">
          <Typography variant="h6" className="os-api-status-notification-message">
            {message}
          </Typography>
        </div>
        {children}
      </div>
    </DialogContent>
    <DialogActions>{actions}</DialogActions>
  </Dialog>
);
